import React, { useMemo } from "react";
import { DefaultButton, Stack, Text } from "@fluentui/react";
import { Lead } from "./AdminStore";

interface LeadDetailProps {
  lead: Lead;
  onBack: () => void;
}

function DetailRow(props: { label: string; value: string }) {
  return (
    <Stack horizontal tokens={{ childrenGap: 12 }} styles={{ root: { marginBottom: 8 } }}>
      <Text styles={{ root: { width: 160, color: "#666" } }}>{props.label}</Text>
      <Text styles={{ root: { flex: 1, wordBreak: "break-word" } }}>{props.value}</Text>
    </Stack>
  );
}

export const LeadDetail: React.FunctionComponent<LeadDetailProps> = ({ lead, onBack }) => {
  const sortedActions = useMemo(
    () =>
      [...lead.actions].sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      ),
    [lead.actions],
  );

  return (
    <Stack tokens={{ childrenGap: 16 }} styles={{ root: { maxWidth: 720, padding: 24 } }}>
      <DefaultButton text="Back to list" onClick={onBack} styles={{ root: { width: 140 } }} />
      <Text variant="xLarge">Lead Detail</Text>
      <DetailRow label="Created" value={new Date(lead.createdAt).toLocaleString()} />
      <DetailRow label="Updated" value={new Date(lead.updatedAt).toLocaleString()} />
      <DetailRow label="Name" value={`${lead.firstName} ${lead.lastName}`} />
      <DetailRow label="Email" value={lead.email} />
      <DetailRow label="Company" value={lead.company} />
      <DetailRow label="Country" value={lead.country} />
      <DetailRow label="Title" value={lead.title} />
      <DetailRow label="Phone" value={lead.phone} />
      <DetailRow label="Random hash" value={lead.randomHash} />
      <Stack tokens={{ childrenGap: 8 }}>
        <Text variant="large">Actions ({sortedActions.length})</Text>
        {sortedActions.length === 0 && <Text>No actions yet.</Text>}
        {sortedActions.map((action, index) => (
          <Stack
            key={`${action.actionCode}-${action.createdAt}-${index}`}
            styles={{
              root: {
                background: "#fafafa",
                padding: 12,
                borderRadius: 4,
                border: "1px solid #eee",
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text>
              <strong>{action.actionCode}</strong> — {action.offerTitle}
            </Text>
            <Text>{action.description}</Text>
            <Text styles={{ root: { color: "#666", fontSize: 12 } }}>
              {action.leadSource} · {new Date(action.createdAt).toLocaleString()}
            </Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
